<template>
  <v-flex xs12>
    <v-layout
      row
      wrap>
      <v-flex
        xs8
      >
        <v-text-field
          v-model="optValue"
          :label="original || $t('Value')"
          class="mx-1"
        />
      </v-flex>
      <v-flex
        xs4
      >
        <v-btn
          icon
          @click="$emit('confirmed')"
        >
          <v-icon>check</v-icon>
        </v-btn>
        <v-btn
          icon
          @click="$emit('canceled')"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  name: 'ProductExtraOption',

  props: {
    value: {
      type: [String, Number],
      default: null
    },
    original: {
      type: String,
      default: null
    }
  },

  computed: {
    optValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
